import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "skill-node"
};
import { inject, ref } from 'vue';
import { ElPopover } from 'element-plus';
import RoleSkillPreviewCard from '@/components/Skills/RoleSkillPreviewCard.vue';
import SectsSkillPreviewCard from '@/components/Skills/SectsSkillPreviewCard.vue';
export default {
  __name: 'SkillsNode',
  props: {
    skill: {
      type: Object,
      required: true
    },
    roleId: {
      type: [String, Number],
      default: null,
      required: false
    }
  },

  setup(__props) {
    const getSubsequentSkillStyle = inject('getSubsequentSkillStyle');
    const skillNode = ref(null);

    const closePopper = () => {
      if (skillNode.value) {
        skillNode.value.hide();
      }
    }; // const convertStyle = computed(() => {
    //   console.log(JSON.stringify(props.skillStyle))
    //   return Object.entries(props.skillStyle).map(([key, value]) => {
    //     if (['x', 'y', 'width', 'height'].includes(key)) {
    //       console.log(key, `${value}px`)
    //       return `${value}px`
    //     }
    //   })
    // })
    //
    // const getSubsequentStyle = (skills, index, pre_skill_id) => () => {
    //   // await nextTick()
    //   console.log(`getSubsequentStyle`)
    //   let buffer = props.subsequentStyle(skills, index, pre_skill_id)
    //   console.log(`getSubsequentStyle ${JSON.stringify(buffer)}`)
    //   return buffer
    // }


    return (_ctx, _cache) => {
      const _component_SkillsNode = _resolveComponent("SkillsNode", true);

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElPopover), {
        placement: "bottom",
        width: "24rem",
        trigger: "click",
        "popper-class": "skill-popper",
        ref_key: "skillNode",
        ref: skillNode
      }, {
        reference: _withCtx(() => [_createElementVNode("text", {
          class: _normalizeClass(__props.skill.learned ? 'learned' : __props.skill.inactive ? 'inactive' : 'desc')
        }, _toDisplayString(__props.skill.name), 3)]),
        default: _withCtx(() => [__props.roleId ? (_openBlock(), _createBlock(RoleSkillPreviewCard, {
          key: 0,
          skill: __props.skill,
          "role-id": __props.roleId
        }, null, 8, ["skill", "role-id"])) : (_openBlock(), _createBlock(SectsSkillPreviewCard, {
          key: 1,
          skill: __props.skill,
          onClosePopper: closePopper
        }, null, 8, ["skill"]))]),
        _: 1
      }, 512), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.skill.subsequent, subsequentSkill => {
        return _openBlock(), _createBlock(_component_SkillsNode, {
          key: subsequentSkill.id,
          skill: subsequentSkill,
          style: _normalizeStyle(_unref(getSubsequentSkillStyle)(subsequentSkill.id)),
          "role-id": __props.roleId
        }, null, 8, ["skill", "style", "role-id"]);
      }), 128))]);
    };
  }

};